export default "__VITE_ASSET__BPUhcMF$__"